import { ParticipantTile, TrackReferenceOrPlaceholder, useEnsureTrackRef } from '@livekit/components-react';
import { Track } from 'livekit-client';

const ParticipantTileWithFallback = ({ trackRef: trackRefProp }: { trackRef?: TrackReferenceOrPlaceholder }) => {
  const trackRef = useEnsureTrackRef(trackRefProp);

  if (trackRef.publication?.kind !== Track.Kind.Video) {
    return (
      <div
        data-lk-audio-muted={true}
        data-lk-video-muted={true}
        data-lk-speaking={false}
        data-lk-local-participant={trackRef.participant.isLocal}
        data-lk-source={Track.Source.Camera}
        data-lk-facing-mode={'undefined'}
        className="lk-participant-tile"
      >
        <video
          className="lk-participant-media-video"
          data-lk-local-participant="false"
          data-lk-source="camera"
          data-lk-orientation="landscape"
          autoPlay={true}
          playsInline={true}
        ></video>
        <div className="lk-participant-placeholder"></div>
      </div>
    );
  }
  return <ParticipantTile trackRef={trackRef} />;
};

export default ParticipantTileWithFallback;
